import React, { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout"
import CmsSideBarLayout from "../CMSSideBarLayout/CMSSideBarLayout"

const CMSViewLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchValue, setSearchValue] = useState("")
  const [cmsList, setCmsList] = useState<any[]>([])

  useEffect(() => {
    setCmsList([
      { id: "contact-info", title: "Contact Info" },
      { id: "social-media", title: "Social Media" },
      {id: "banners", title: "Banners"},
    ])
  }, [])

  useEffect(() => {
    if (cmsList.length > 0 && location.pathname === "/cms") {
      navigate(`/cms/${cmsList[0].id}`, { replace: true })
    }
  }, [cmsList, location.pathname, navigate])

  return (
    <SideNavLayout>
      <div className="flex h-full">
        {/* Sidebar */}
        <CmsSideBarLayout
          listData={cmsList}
          searchValue={searchValue}
          onSearch={setSearchValue}
          onClickItem={(id: any) => navigate(`/cms/${id}`)}
        />

        <div className="w-full flex flex-col h-[calc(100vh-50px)]">
          <div className="grow overflow-auto bg-gray-50 p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </SideNavLayout>
  )
}

export default CMSViewLayout
